<template>
  <el-dialog
    append-to-body
    width="600px"
    title="修改密码"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="130px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item prop="password" label="密码">
        <el-input
          v-model="form.data.password"
          minlength="6"
          clearable
          placeholder="请输入密码"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password2" label="确认密码">
        <el-input
          v-model.trim="form.data.password2"
          minlength="6"
          clearable
          placeholder="请输入密码"
        ></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
  export default {
    name: 'Password',
    data() {
      return {
        visible: false,
        isChange: false,
        loading: false,
        form: {
          loading: false,
          data: {
            id: '',
            password: '',
            password2:'',
          },
          rules: {
            password: [{required: true, message: "请输入密码！", trigger: "change"}],
            password2: [
              {required: true, message: "请输入密码！", trigger: "change"},
              { validator: this.checkPwdSame, trigger: ['blur', 'change'] }
            ],
          }
        }
      }
    },
    methods: {
      checkPwdSame(rule, value, callback) {
        if (value !== this.form.data.password) {
          return callback(new Error('两次输入密码不一致'))
        }
        callback()
      },
      // 获取详情
      getDetail(row) {
        this.isChange = true
        this.form.data = row
      },
      reset(done) {
        this.isChange = false
        this.$refs.elFormDom.resetFields()
        done && done()
      },
      toggle(show) {
        this.visible = show
        !show && this.reset()
      },
      // 提交
      confirm() {
        this.$refs.elFormDom.validate(valid => {
          if (valid) {
            let {id, password } = this.form.data;
            this.form.loading = false;
            this.$http.post('/admin/flex_admin/updatePassword', { id:id, password:password }).then(res => {
              if(res.code === 1) {
                this.$message.success('操作成功！')
                this.toggle(false)
              } else {
                this.$message.error(res.msg)
              }
           }).finally(() => {
             this.form.loading = false;
           })
          }
        })
      }
    }
  }
</script>
